import { ThreeStepCtaBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpThreeStepCtaBlock } from './AmpThreeStepCtaBlock';
import { ThreeStepCtaBlock } from './ThreeStepCtaBlock';

export const ThreeStepCtaBlockMapping: BlockMapping<ThreeStepCtaBlockData> = {
  invariant: [
    {
      prop: 'mainHeadline',
      msg: 'Main Heading required for Three Step Call-to-Action',
    },
  ],
  width: 'GRID',
  Component: ThreeStepCtaBlock,
  AmpComponent: AmpThreeStepCtaBlock,
};
